import HeroBg from "public/complianceMngmnt/hero-section-background.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Streamline Compliance & SEC Ops",
    link: "contact-us",
  },
  title: "Simplify Compliance with Integrated Security Operations ",
  desc: "Unify governance, risk, and security operations to meet regulatory mandates and reduce audit fatigue. ",
  image: HeroBg,
};
